import React, { useEffect, useState, useCallback } from "react";
import Router from "./Router";
import { login } from "./store/authSlice";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import LoadingModal from "./components/shared/loadingModal";

interface Props {}

const App: React.FC<Props> = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  // Directly use useAppSelector without useMemo
  const loggedIn = useAppSelector((state) => state.auth.loggedIn);

  // useCallback to memoize checkLoginStatus function
  const checkLoginStatus = useCallback(async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);

      // Consolidate access to URL params and local storage
      const accessToken =
        urlParams.get("accessToken") || localStorage.getItem("accessToken");
      const email = urlParams.get("email") || localStorage.getItem("email");
      const refreshToken = urlParams.get("refreshToken");

      if (accessToken && email) {
        if (refreshToken) {
          // Only update localStorage if URL contains new data
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("email", email);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.removeItem("impersonate");
          // Use replaceState for efficient URL cleanup
          window.history.replaceState(
            null,
            "",
            window.location.origin + window.location.pathname
          );
        }

        // Dispatch login only if user is not already logged in
        if (!loggedIn) {
          await dispatch(login({ email, accessToken }));
        }
      }
    } catch (err) {
      console.error("Error during login:", err);
      setError("An error occurred while logging in. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [dispatch, loggedIn]);

  useEffect(() => {
    checkLoginStatus();
  }, [checkLoginStatus]);

  // Loading indicator while checking authentication
  if (loading) {
    return <LoadingModal show={loading} />;
  }

  // Error message if login fails
  // if (error) {
  //   return (
  //     <div className="position-fixed h-100 w-100">
  //       <div className="p-4 h-100 d-flex flex-column justify-content-center align-items-center">
  //         <h2>Error</h2>
  //         <p>{error}</p>
  //       </div>
  //     </div>
  //   );
  // }

  return loggedIn ? (
    <Router />
  ) : (
    <div className="position-fixed h-100 w-100">
      <div className="p-4 h-100 d-flex flex-column justify-content-center align-items-center">
        <h1>Please Log In</h1>
        <a
          className="btn btn-secondary"
          href={process.env.REACT_APP_API_LOGIN_URL}
        >
          Login
        </a>
      </div>
    </div>
  );
};

export default App;
